import {  IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import { LogoutUser } from "../logout/logout";
import "./headerStyle.css";

interface IHeaderProps {
    element?: JSX.Element;
    title: string;
    className?: string;
    showLogout: boolean;
}

const Header: React.FC<IHeaderProps> = ({ element, title, className, showLogout }) => {
    return (
        <IonHeader color={"tertiary"}>
            <IonToolbar className="ion-text-left">
                {element && element}
                {title && <IonTitle>{title}</IonTitle>}
                {showLogout && <LogoutUser></LogoutUser>}
            </IonToolbar>
        </IonHeader>
    );
};

export default Header;
